// import DashboardPageLayout from "../Pages/DashboardPageLayout";
import Home from "../Pages/Home/Home";
// import { RouteType } from "./config";
// import DefaultPage from "../pages/dashboard/DefaultPage";
// import DashboardIndex from "../pages/dashboard/DashboardIndex";
// import ChangelogPage from "../pages/changelog/ChangelogPage";
// import AnalyticsPage from "../pages/dashboard/AnalyticsPage";
// import SaasPage from "../pages/dashboard/SaasPage";
// import ComponentPageLayout from "../pages/component/ComponentPageLayout";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// import AlertPage from "../pages/component/AlertPage";
// import ButtonPage from "../pages/component/ButtonPage";
// import InstallationPage from "../pages/installation/InstallationPage";
// import DocumentationPage from "../pages/documentation/DocumentationPage";
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AcUnitIcon from '@mui/icons-material/AcUnit';

const appRoutes = [
  {
    to: '/',
    name: "Market Master View",
    icon: <AutoAwesomeMosaicIcon/>
  },
  {
    to: '/',
    name: "Daily Trade View",
    icon: <CandlestickChartIcon/>
  },
  {
    to: '/',
    name: "Stock Fundamentals",
    icon: <QuestionAnswerIcon/>
  },
  {
    to: '/',
    name: "Bio Tech Corner",
    icon: <HourglassFullIcon/>
  },
  {
    to: '/',
    name: "Sentiment Analysis",
    icon: <EmojiEmotionsIcon/>,
  },
  {
    to: '/',
    name: "AI Prediction",
    icon: <AcUnitIcon/>,
  },
  {
    to: '/',
    name: "Market Broadview",
    icon: <AssignmentIcon/>,
  },
  {
    to: '/',
    name: "Options",
    icon: <CreateNewFolderIcon/>,
  },
  {
    to: '/',
    name: "Academy",
    icon: <EmojiEmotionsIcon/>,
  },
  {
    to: '/',
    name: "Pharmbizz News",
    icon: <EmojiEmotionsIcon/>,
  },
];

export default appRoutes;